module.exports = __webpack_public_path__ + "static/media/bar-vertical-100-icon.985a39d5.svg";